const distributionConfig = {
  fieldsToCalculate: ['countExecutedDistribution'],
  preparingFields: ['countPreparingDistribution'],
  startAtField: 'startAtDistribution',
};

export const simulationConfig = {
  SIMULATION: {
    fieldsToCalculate: ['countExecutedSimulation'],
    preparingFields: ['countPreparingSimulation'],
    startAtField: 'startAtSimulation',
  },
  DISTRIBUTION: distributionConfig,
  PERSIST_DISTRIBUTION: distributionConfig,
};

const isDevelopmentEnv = process.env.NODE_ENV === 'development';

export const MIN_EXECUTED_PERCENT_TO_START = 35;
const MINUTES_TO_START = isDevelopmentEnv ? 2 : 10;
export const TIME_TO_START_PREVISION = MINUTES_TO_START * 60 * 1000; // min * seg * ms

export const DRILL_DOWN_TIME_INTERVAL = isDevelopmentEnv ? 10000 : 30000;
